/**
* @public
*/
const MediaStates = {
	WIRING				: 'WIRING',
	WIRED				: 'WIRED',
	ATTACHING			: 'ATTACHING',
	ATTACHED 			: 'ATTACHED',
	DETACHING 			: 'DETACHING',
	DETACHED			: 'DETACHED', // initial state
};

export default MediaStates;



// WEBPACK FOOTER //
// ./src/MediaStates.js